import { Button, Form, Input, Schema } from 'rsuite';
import { useCallback, useEffect, useRef, useState } from 'react';
import Field from '../../../components/form/field';
import OtpInput from 'react-otp-input';
import { postConfirmCode, postRequestCode } from '../../../core';
import { showToast } from '../../../utils/toast';
// import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import IconTextField from '../../../components/form/icon-textfield';
import { Hide, Show } from 'react-iconly';
import { useUser } from '../../../contexts/user';

const { StringType } = Schema.Types;
const otpModel = Schema.Model({
  activation_code: StringType('')
    .minLength(6, 'کد ارسال شده را وارد کنید.')
    .isRequired('کد ارسال شده را وارد کنید.')
});
const resetModel = Schema.Model({
  activation_code: StringType('')
    .minLength(6, 'کد ارسال شده را وارد کنید.')
    .isRequired('کد ارسال شده را وارد کنید.'),
  password: StringType('فرمت پسورد صحیح نیست.')
    .pattern(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      'پسورد هشت رقمی شما باید شامل حروف کوچک و بزرگ و اعداد باشد.'
    )
    .isRequired('پسورد را وارد کنید.')
});

interface OTPStepProps {
  type: 'otp' | 'reset';
  userData: {
    mobile_number: string;
    password: string;
  };
}
const DEFAULT_CODE_TIME = 120;
export const OTPStep = (props: OTPStepProps) => {
  const { userTrigger, setUserTrigger } = useUser();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [codeSentLoading, setCodeSentLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(DEFAULT_CODE_TIME);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formRef = useRef<any>(null);
  const [formError, setFormError] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formValue, setFormValue] = useState<any>({});
  const [otp, setOtp] = useState('');

  const formatTimeLeft = (time: number) => {
    const minute = Math.floor(time / 60);
    let second: string | number = time % 60;
    if (second < 10) {
      second = `0${second}`;
    }
    return `${minute}:${second}`;
  };

  const handleSendCode = useCallback(async () => {
    setCodeSentLoading(true);
    setTimeLeft(DEFAULT_CODE_TIME);

    // send code
    try {
      const { status } = await postRequestCode(props.userData.mobile_number);
      if (status === 200) {
        setCodeSent(true);
        let timer = timeLeft;
        const interval = setInterval(() => {
          setTimeLeft((prev) => prev - 1);
          timer--;
          if (timer <= 0) {
            setCodeSent(false);
            clearInterval(interval);
          }
        }, 1000);
      } else {
        showToast('کد ارسال نشد لطفا دقایقی بعد دوباره تلاش کنید.', 'error');
      }
    } catch (e) {
      showToast('کد ارسال نشد لطفا دقایقی بعد دوباره تلاش کنید.', 'error');
      console.log(e);
    }

    // code sent successfully

    setCodeSentLoading(false);
  }, [timeLeft, props.userData]);

  const handleSubmit = useCallback(async () => {
    if (formRef.current && !formRef.current.check()) {
      console.log('formError', formError);
      return;
    }
    setLoading(true);

    console.log('submitted', formValue);
    console.log('userData', props.userData);
    const password = props.type === 'reset' ? formValue.password : props.userData.password;
    try {
      const { data, status } = await postConfirmCode(
        props.userData.mobile_number,
        password,
        formValue.activation_code,
        props.type
      );
      if (status === 200) {
        if (data.state === 'error') {
          showToast(data.message, 'error');
        } else if (data.state === 'success') {
          showToast(data.message, 'success');
          localStorage.setItem('token', data.token);
          setUserTrigger(!userTrigger);

          navigate('/feed');
        }
      } else {
        showToast('کد وارد شده صحیح نمی باشد!.', 'error');
      }
    } catch (e) {
      showToast('کد وارد شده صحیح نمی باشد.', 'error');
      console.log(e);
    }
    setLoading(false);
  }, [formValue, formError, formRef, props.userData, props.type]);

  useEffect(() => {
    handleSendCode();
  }, [props.type]);

  return (
    <>
      <Form
        ref={formRef}
        onChange={setFormValue}
        onCheck={setFormError}
        formError={formError}
        model={props.type === 'otp' ? otpModel : resetModel}
        onSubmit={handleSubmit}
        checkTrigger="blur"
        className="pt-10">
        {props.type === 'otp' ? (
          <p className="text-center w-[92%] mx-auto mb-8 text-base text-[--rs-pink]">
            درصورت دریافت کد، آن را در کادر زیر وارد کنید، در غیر این صورت پس از سپری شدن زمان
            انتظار با زدن دکمه <b>*ارسال مجدد کد تایید*</b> کد جدیدی دریافت کنید.
          </p>
        ) : (
          <p className="text-center w-[92%] mx-auto mb-8 text-base text-[--rs-pink]">
            درصورت دریافت کد آن را وارد کنید و سپس یک پسورد جدید انتخاب کنید.
          </p>
        )}
        <div className="w-[95%] xs:w-[80%] mx-auto">
          <Field
            dir="rtl"
            accepter={OtpInput}
            value={otp}
            isInputNum={true}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange={(value: any) => setOtp(value)}
            inputStyle="rs-input otp-input min-w-[2.5em] sm:min-w-[3em] me-1 ms-0 aspect-square justify-center"
            containerStyle={{ flexDirection: 'row-reverse' }}
            numInputs={6}
            separator={<span></span>}
            name="activation_code"
            label=""
          />
          {props.type === 'reset' ? (
            <IconTextField
              name="password"
              label="پسورد جدید را وارد کنید"
              type={visible ? 'text' : 'password'}
              accepter={Input}
              dir="ltr"
              onIconCLick={() => setVisible(!visible)}
              eyeVisible={visible}
              onIcon={<Hide size="small" />}
              offIcon={<Show size="small" />}
            />
          ) : null}
        </div>
        <div className="flex justify-center w-[95%] xs:w-[80%] mx-auto mt-5">
          <Button
            appearance="primary"
            type="submit"
            className="w-full btn-outline"
            loading={loading}>
            {props.type === 'reset' ? 'ایجاد پسورد جدید' : 'تایید ثبت نام'}
          </Button>
        </div>
      </Form>
      <div className="flex justify-around items-center mx-auto w-[95%] xs:w-[80%] mt-5">
        <Button
          appearance="primary"
          className="w-[50%] btn-outline"
          disabled={codeSent}
          onClick={handleSendCode}
          loading={codeSentLoading}>
          ارسال مجدد کد تایید
        </Button>
        <div className="text-md text-[--rs-pink] w-[50px]">{formatTimeLeft(timeLeft)}</div>
      </div>
    </>
  );
};
